import {
  DataModelsPaymentTransactionProperties,
  OrdersDtoOrderDto,
  OrdersDtoOrderLineDto,
  OrdersOpenOrderAmounts,
} from "@springtree/eva-services-core";
import { DateTime } from "ts-luxon";

import Constants from "./constants";

const orderUtils = {
  calculateTotals(order: OrdersDtoOrderDto, amounts: OrdersOpenOrderAmounts, withTax?: boolean) {
    const discountLines = amounts.Discounts?.PerDiscount;

    const subtotal = amounts.Types?.NormalProduct
      ? withTax
        ? Math.abs(amounts.Types.NormalProduct.Amount)
        : Math.abs(amounts.Types.NormalProduct.InTax)
      : 0;
    const total = amounts.Total ? Math.abs(amounts.Total.InTax) : 0;
    const taxTotal = withTax && amounts.Total ? Math.abs(amounts.Total.Tax) : 0;
    const giftWrapping = amounts.Types?.GiftWrappingCosts
      ? withTax
        ? Math.abs(amounts.Types.GiftWrappingCosts.Amount)
        : Math.abs(amounts.Types.GiftWrappingCosts.InTax)
      : 0;

    const shippingCostsLine = orderUtils.getShippingLine(order);

    const shipping = shippingCostsLine
      ? withTax
        ? Math.abs(shippingCostsLine.NetTotalAmount)
        : Math.abs(shippingCostsLine.NetTotalAmountInTax)
      : 0;

    const shippingMethod =
      order?.Lines?.find((line) => line.ShippingMethod && !line.IsCancelled)?.ShippingMethod!.Name || null;

    return {
      total,
      subtotal,
      discountLines: discountLines,
      giftWrapping,
      shipping,
      tax: taxTotal,
      estimated: false,
      shippingMethod,
    };
  },
  getOrderReturnWindowDays(): number {
    return Math.floor(Number(process.env.NEXT_PUBLIC_RETURN_WINDOW_DAYS)) ?? Constants.DEFAULT_RETURN_WINDOW_DAYS;
  },
  getOrderReturnMaxDate(deliveryDate: string): Date {
    return DateTime.fromISO(deliveryDate).plus({ days: this.getOrderReturnWindowDays() }).toJSDate();
  },
  getOrderReturnDaysFromNow(deliveryDate: string): number {
    return Math.ceil(DateTime.fromJSDate(this.getOrderReturnMaxDate(deliveryDate)).diff(DateTime.now(), "days").days);
  },
  getShippingLine(order: OrdersDtoOrderDto): OrdersDtoOrderLineDto | undefined {
    return order?.Lines?.find((line) => line.Type === 5 && !line.IsCancelled);
  },
  isOrderEligibleForReturn(deliveryDate: string): boolean {
    return this.getOrderReturnDaysFromNow(deliveryDate) >= 0;
  },
  isReturn(order: OrdersDtoOrderDto): boolean {
    return order.TotalAmountInTax < 0;
  },
  isCancelledByFraudHandler(order: OrdersDtoOrderDto): boolean {
    return (
      !!order.IsCompleted &&
      order.Lines!.every((l) => l.IsCancelled) &&
      order.Payments!.some((p) => {
        if (p.IsAuthorizationAdjustment) {
          const targetTransaction = order.Payments!.find((t) => {
            return t.ID === (p as any)["ReturnedPaymentTransactionID"];
          });

          return (
            ((targetTransaction?.Properties || 0) & DataModelsPaymentTransactionProperties.FraudCheckDenied) ===
            DataModelsPaymentTransactionProperties.FraudCheckDenied
          );
        }
      })
    );
  },
};

export default orderUtils;
